/* eslint jsx-a11y/aria-role: 0 */
/* eslint array-callback-return: 0 */
import React from "react";
import { connect } from "react-redux";
import RaisedButton from "material-ui/RaisedButton";
import styled from "styled-components";


import {
  productHasSizes,
  getProductName,
  titleArray,
  bubbleSort,
  getTotalProductPriceWithCustomTaxes,
  getClassificationClass,
  decodeHtmlEntity,
  nl2br,
  convertProductToCartItem
} from "../../helpers/productHelper";
import { getSpecificIcon } from "../../helpers/producttypes.js";
import { BODY_TEXT_COLOR } from "../../config/colors";
import * as uri from "../../config/uri";

import ProductImage from "../ProductImage";
import QuantityPicker from "../QuantityPicker";
import KioskQuantityPicker from "../KioskQuantityPicker";
import AddressBar from "../../components/AddressBar";

import { addProduct, getItemQnt, cartUpdated } from "../../reducers/cartReducer";
import * as addressReducer from "../../reducers/addressReducer";
import * as userReducer from "../../reducers/userReducer";
import * as modal from "../../reducers/modalReducer";
import { holdProduct } from "../../reducers/holdProductReducer";

import { fetchByProductsById } from "../../actions/api";
import { fetchMoreByCategory } from "../../actions/api";
import { setProduct } from "../../actions/product";

import "./style.kiosk.css";
import { getCategoryNames } from "../../reducers/configReducer";
import {isKioskCustomerSelector} from '../../selectors/userSelectors';
import LabDataValue from "../LabDataValue/lab_data_value";
import { getUomDisplayVal, isAttribute, getNumberViewVal } from "../../helpers/attribute_util";
import { PRODUCT_ATTRIBUTE } from "../../const/attribute";
import { isPostTaxEnabled } from "../../selectors/configSelectors";

import {
  isShippingForm,
  isPaymentKiosk as isPaymentKioskSelector
} from '../../selectors/configSelectors';
import { getProducts } from "../../selectors/product_selector";
import { pushWithQueryParams } from "../../services/uri";

const styles = {
  labelStyle: { fontWeight: 700, width: '90%' },
  button: {
    margin: 12,
    width: "250px",
    height: "50px",
    lineHeight: "50px",
    fontSize: "18px"
  },
  labResultTitle: { fontWeight: 800, paddingRight: "5px" }
};
class ProductDetailViewNewKiosk extends React.PureComponent {
  buttonStyle = { border: "1px solid #" + this.props.secondaryColor  };
  content = null;
  constructor(props) {
    super(props);
    this.state = {
      product: {}
    };
  }

  onBackButtonEvent = () => {
    const index = this.props.currentProduct.index;
    const productId = this.props.match.params.product;
    if (
      this.props.products[index - 1] &&
      this.props.products[index - 1].categoryId === productId
    ) {
      let product = this.props.products[index - 1];
      product.index = index - 1;
      this.setProduct(product);
    } else if (
      this.props.products[index + 1] &&
      this.props.products[index + 1].categoryId === productId
    ) {
      let product = this.props.products[index + 1];
      product.index = index + 1;
      this.setProduct(product);
    }
  };

  componentDidMount() {
    window.onpopstate = this.onBackButtonEvent;
    if (this.props.products.length === 0) {
      // fetch products
      const catName = this.props.match.params.category;
      const allowed = this.props.allowedCategories.indexOf(catName.toUpperCase()) !== -1;
      if (!allowed) {
        this.props.go(uri.rootPageUri + "category/flower");
        return;
      }
      const productId = this.props.match.params.product;
      this.props.fetchByProductsById(catName, productId).then(res => {
        let product = res.productGrouplist[res.categoryIndex];
        if (!product) {
          this.props.go(uri.rootPageUri + "category/flower");
          return;
        }
        product.index = res.categoryIndex;
        this.setProduct(product);
      });
    } else {
      // get item from prop
      const product = this.props.currentProduct;
      this.setProduct(product);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.product !== nextProps.match.params.product) {
      // fetch product if changed
      if (
        this.props.products.length - this.props.currentProduct.index < 5 &&
        this.props.currentCategoryCount < this.props.totalPages
      ) {
        const catName = this.props.match.params.category;
        this.props.fetchMoreProducts(catName, this.props.products.length, 20);
      }
    }
  }

  componentWillUnmount() {
    setTimeout(() => this.props.restoreBody(this.props.bodyScrollTop), 300);
  }

  setProduct = product => {
    this.props.setCurrentProduct(product);
    let productList = this.mapSizes(product.productList);
    this.setState({
      isAddingToCart: false,
      /* In case of a product with only one size we auto select it */
      selectedProduct: productList.length === 1 ? productList[0] : null,
      liveUnits: productList.length === 1 ? productList[0].unitsInStock : null,
      selectedSizeId:
        productList.length === 1 ? productList[0].productId : null,
      currentSizeQuantity: 1,
      // need to save adjusted flag for changing to next|prev product
      // isHightAdjusted: false,
      product
    });
  };

  mapSizes = sizes => {
    const { menuRoundTax } = this.props;
    const newSizes = sizes.map((size, index) => {
      if (size.priceSell > 0) {
        return {
          ...size,
          index: index,
          priceSell: getTotalProductPriceWithCustomTaxes(size, menuRoundTax).toFixed(2),
          initialPriceSell: size.priceSell
        };
      }
    });
    return newSizes;
  };
  isAddressBar = () => {
    return this.props.isAddressBarOpened;
  };
  handlePrevProduct = () => {
    const nextProduct = this.props.products[this.state.product.index - 1];
    nextProduct.index = this.state.product.index - 1;
    const url = `${
      uri.rootPageUri
    }category/${this.state.product.type.toLowerCase()}/item/${
      nextProduct.categoryId
    }`;
    this.props.go(url);
    this.setProduct(nextProduct);
  };

  handleNextProduct = () => {
    const nextProduct = this.props.products[this.state.product.index + 1];
    nextProduct.index = this.state.product.index + 1;
    const url = `${
      uri.rootPageUri
    }category/${this.state.product.type.toLowerCase()}/item/${
      nextProduct.categoryId
    }`;
    this.props.go(url);
    this.setProduct(nextProduct);
  };
  onImgLoaded = () => {
    this.setState({
      ringSpinner: false
    });
  };
  /* is there address selected */
  isAddress = () => {
    return this.props.currentAddress !== "";
  };
  isThc = (value, type) => {
    if (type === "EDIBLE") {
      return false;
    }
    return value && value !== "-.-" ? true : false;
  };

  handleSizeClick = size => {
    let state = {
      selectedProduct: size,
      liveUnits: size.unitsInStock,
      selectedSizeId: size.productId,
      currentSizeQuantity: 1
    };
    this.setState(state);
  };

  imgError = event => {};

  mainPage = () => {
    this.props.go(uri.rootPageUri);
  }

  handleAddToCartClick = sizeId => {
    const {isKioskCustomer, isPaymentKiosk} = this.props;
    const {
      product,
      selectedProduct,
      currentSizeQuantity,
    } = this.state;

    const ticketLineItem = convertProductToCartItem(
      product,
      selectedProduct,
      currentSizeQuantity,
    )

    if (!isKioskCustomer || isPaymentKiosk) {
      if (!this.props.isUser) {
        // if user is not logged in - save order to state
        this.props.holdProduct({type: "cart", product: ticketLineItem});
        this.props.openLoginForm(isPaymentKiosk);
        return;
      }
      if (this.props.isShippingForm && !this.isAddress()) {
        this.props.openShippingForm({
          handleClose: this.handleAddToCartClick
        });
        return;
      }
    }

    // sizeId equals productId
    this.setState(
      {
        isAddingToCart: true
      },
      this.setAddedToCart
    );

    this.props.addProduct(ticketLineItem);
    this.props.openItemAdded();
    this.mainPage();
  };

  setAddedToCart = () => {
    setTimeout(() => {
      this.setState({
        isAddingToCart: false
      });
    }, 1000);
  };

  isSizeActive = (productId, defaultProductId) => {
    return (
      this.state.selectedProduct &&
      this.state.selectedProduct.productId === productId
    );
  };
  isLabResults = () => {
    const { product } = this.state;
    return (
      this.isThc(product.thc, product.type) ||
      this.isCbd(product.cbd, product.type) ||
      this.isTerp(product.terps, product.type) ||
      this.isCbdPercent(product.cbdPercent, product.type)
    );
  };
  handleSelectSize = () => {
    let productList = this.mapSizes(this.state.product.productList);
    let state = {
      liveUnits: productList[0].unitsInStock,
      selectedSizeId: productList[0].productId,
      selectedProduct: productList[0],
      currentSizeQuantity: 1
    };
    this.setState(state);
  };

  handleQuantityChange = quantity => {
    // this.props.openItemAdded({msg:''});
    this.setState({
      currentSizeQuantity: quantity
    });
  };

  /**
  moev to util class
  */
  isTerp = (value, type) => {
    if (type === "EDIBLE") {
      return false;
    }
    return value && value !== "-.-" ? true : false;
  };

  isCbdPercent = (value, type) => {
    if (type === "EDIBLE") {
      return false;
    }
    return value && value !== "-.-" ? true : false;
  };

  isThc = (value, type) => {
    if (type === "EDIBLE") {
      return false;
    }
    return value && value !== "-.-" ? true : false;
  };
  isCbd = (value, type) => {
    if (type === "EDIBLE") {
      return false;
    }
    return value && value !== "-.-" ? true : false;
  };
  /** Fill empty space for symmetry */
  getFakeSizes = length => {
    if (length === 4) {
      return [
        <div key={1} className="kiosk-box" style={{ visibility: "hidden" }} />,
        <div key={2} className="kiosk-box" style={{ visibility: "hidden" }} />
      ];
    } else if (length === 5) {
      return <div className="kiosk-box" style={{ visibility: "hidden" }} />;
    } else {
      return null;
    }
  };

  getClassification(classifications) {
    if (classifications.length > 0) {
      return classifications[0];
    } else {
      return "";
    }
  }

  hasPrev = () => {
    return this.state.product.index > 0;
  };
  hasNext = () => {
    const totalProducts = this.props.products.length - 1;
    return this.state.product.index < totalProducts;
  };

  /**
   * Dangerously Set innerHTML
   */
  getDescription = (product) => {
    const description = product.description ? nl2br(decodeHtmlEntity(product.description)) : '';
    return {__html: description };
  }

  render() {
    const { product } = this.state;
    if (Object.keys(product).length === 0) return null;
    const { selectedSizeId } = this.state;
    const name = getProductName(product);
    const sizes = this.mapSizes(product.productList);
    const sizesSorted = bubbleSort(sizes);
    const flavors = titleArray(product.flavors).join(", ");
    const effects = titleArray(product.effects).join(", ");
    const sizeWrapperStyle = sizes.length < 4 ? "__1_row" : "";
    const classificClName = getClassificationClass(product);
    const classification = this.getClassification(product.classifications);
    const contentClass = this.props.isAddressBarOpened ? "adjust-margin" : "";
    const attributes = product.generalAttrs.map((attribute, index) => (
      <div key={index} className="attribute">
        {attribute}
      </div>
    ));
    const subTypes = product.subTypes.map((subType, index) => (
      <div key={index} className="attribute">
        {subType}
      </div>
    ));
    const unitOfMeasurement = getUomDisplayVal(product.unitOfMeasurement);
    const productSize = isAttribute(product, PRODUCT_ATTRIBUTE.SIZE) ? <span className="attribute">{product.size}&nbsp;{unitOfMeasurement}</span> : undefined;
    const medium = <span className="attribute">{product.medium}</span>;
    const mgDose = product.totalDoses > 0 ? <span className="attribute">{product.totalDoses} DOSES</span> : null;
    const mgTotal = product.mgDose ? <span className="attribute">{product.mgDose} MG THC</span> : null;
    const cbdRatio = <div className="attribute">{product.cbdRatio}</div>;
    const sizeHtmlList = sizesSorted.map((size, index) => (
      <div
        onClick={this.handleSizeClick.bind(null, size)}
        key={index}
        className={
          "kiosk-box " + (this.isSizeActive(size.productId, -1) ? "active" : "")
        }
        data-id={size.index}
      >
        <div className="priceWrap">
          <span className="dollar">$</span>
          <div className="price">{size.priceSell}</div>
        </div>
        {productHasSizes(product.type, size) && (
          <div className="weight">{size.weight}&nbsp;{unitOfMeasurement}</div>
        )}
      </div>
    ));
    const fakeSizes = this.getFakeSizes(sizesSorted.length);
    const taxText = this.props.postTaxEnabled ? "All Taxes Included" : "Plus Tax";
    const contentStyle = { height: this.state.contentHeight };
    const unitsInCart = selectedSizeId
      ? this.props.getQntInCart(selectedSizeId)
      : 0;
    const maxUnits =
      this.state.liveUnits - unitsInCart; /* live units selected size */
    return (
      <div>
        <div className="product__wrapper">
          <div
            className={`content ${contentClass}`}
            style={contentStyle}
            ref={content => {
              this.content = content;
            }}
          >
            <div className="treez-item-kiosk">
              <div role="product image" className="img-wrapper">
                <ProductImage
                  handlePrevProduct={this.handlePrevProduct}
                  handleNextProduct={this.handleNextProduct}
                  hasPrev={this.hasPrev()}
                  hasNext={this.hasNext()}
                  imageUrl={product.largeImage}
                  noProductImage={this.props.noProductImage}
                />
                <div className="type-icon-wrapper">
                  <span>{getSpecificIcon(product.type, BODY_TEXT_COLOR)}</span>
                </div>
              </div>

              <div role="product details" className="product-details">
                <div className="wrapper">
                  <div className="item-text-1 uppercase">{product.brand}</div>
                  <div className="item-text-2 uppercase text-color">{name}</div>
                  <div className="item-text-4">
                    <div className={`classification ` + classificClName}>
                      {classification}
                    </div>
                    {product.generalAttrs && (
                      <span role="general">{attributes}</span>
                    )}
                    {product.subTypes && <span role="subtype">{subTypes}</span>}
                    {productSize && <span role="size">{getNumberViewVal(productSize)}&nbsp;{unitOfMeasurement}</span>}
                    {product.medium && <span role="medium">{medium}</span>}
                    {product.mgDose && (
                      <span role="mgdose">{mgDose}</span>
                    )}
                    {mgTotal && (
                      <span role="mgtotal">{mgTotal}</span>
                    )}
                    {product.cbdRatio && (
                      <span role="cbdratio">{cbdRatio}</span>
                    )}
                  </div>
                  <div
                    className="labresults-wrapper-kiosk"
                    style={{ display: this.isLabResults() ? "" : "none" }}
                  >
                    {this.isThc(product.thc, product.type) && (
                      <span className="labresults">
                        <span className="attribute-results white">
                          <LabDataValue style={styles.labResultTitle} name="THC" value={product.cbd} />
                        </span>
                      </span>
                    )}
                    {this.isCbd(product.cbd, product.type) && (
                      <span className="labresults">
                        <span className="attribute-results white">
                          <LabDataValue style={styles.labResultTitle} name="CBD" value={product.cbd} />
                        </span>
                      </span>
                    )}
                    {this.isTerp(product.terps, product.type) && (
                      <span className="labresults">
                        <span className="attribute white">
                          <span style={styles.labResultTitle}>TERPS</span>
                          {product.terps}
                          <sup>%</sup>
                        </span>
                      </span>
                    )}
                  </div>
                </div>

                <div className={`size-container `}>
                  <div className="size-inner-container ">
                    <div className={`kiosk-size-wrapper `}>
                      {sizeHtmlList}
                      {fakeSizes}
                    </div>
                  </div>

                  <div className="plus_tax-container-kiosk">
                    <div className="plus_tax-kiosk">{taxText}</div>
                  </div>

                </div>

                {this.props.isEcommerceEnabled && (
                  <div>
                    <div className="button-wrapper">
                      {this.state.selectedProduct && (
                        <div
                          style={{
                            textAlign: "center",
                            marginBottom: "10px"
                          }}
                        >
                        {maxUnits > 0 && (
                          <div style={{ padding: "0 0 10px" }}>
                            <KioskQuantityPicker
                              secondaryColor={this.props.secondaryColor}
                              max={maxUnits}
                              count={this.state.currentSizeQuantity}
                              onChange={this.handleQuantityChange}
                            />
                          </div>
                        )
                        }
                          {maxUnits > 0 && (
                            <div style={{position:'fixed', bottom:'0', right:0, left:0, padding: '0 0 30px'}}>
                              <RaisedButton
                                onClick={this.handleAddToCartClick}
                                backgroundColor="#FFF"
                                labelColor={`#fff`}
                                label="Add To Cart"
                                labelStyle={{fontWeight: 700, fontSize: '40px', fontColor:'#fff'}}
                                buttonStyle= {{height: '120px', backgroundColor: `#${this.props.secondaryColor}`}}
                                style={{
                                  width:'90%',
                                  boxShadow: "none",
                                }}
                              />
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
                <LabResultsWrapperDiv>
                  <div className="attributes-wrapper">
                    {product.flavors.length > 0 && (
                      <div className="attributes">
                        {" "}
                        <AttributeNameSpan>Flavors:</AttributeNameSpan>
                        {flavors}
                      </div>
                    )}
                    {product.effects.length > 0 && (
                      <div className="attributes">
                        {" "}
                        <AttributeNameSpan>Effects:</AttributeNameSpan>
                        {effects}
                      </div>
                    )}
                  </div>
                </LabResultsWrapperDiv>

                {product.description && maxUnits === 0 && (
                  <div className="description-kiosk" dangerouslySetInnerHTML={this.getDescription(product)}></div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isEcommerceEnabled: state.config.isEcommerceEnabled,
    getQntInCart: productId => getItemQnt(state, productId),
    isAddressBarOpened: addressReducer.isAddressBarOpened(state),
    currentAddress: addressReducer.currentAddress(state),
    isUser: userReducer.isUser(state),
    primaryColor: state.config.primaryColor,
    secondaryColor: state.config.secondaryColor,
    menuRoundTax: state.config.menuRoundTax,
    products: getProducts(state).data,
    currentCategoryCount: state.products.currentCategoryCount,
    totalPages: state.products.totalPages,
    currentProduct: state.products.currentProduct,
    bodyScrollTop: state.view.pos,
    allowedCategories: getCategoryNames(state),
    postTaxEnabled: isPostTaxEnabled(state),
    noProductImage: state.config.NO_PRODUCT_IMAGE,
    isKioskCustomer: isKioskCustomerSelector(state),
    isShippingForm: isShippingForm(state),
    isPaymentKiosk: isPaymentKioskSelector(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addProduct: product => {
      dispatch(addProduct(product));
      dispatch(cartUpdated());
    },
    holdProduct: product => dispatch(holdProduct(product)),
    fetchByProductsById: (catName, id) =>
      dispatch(fetchByProductsById(catName, id)),
    openLoginForm: (isPaymentKiosk) =>
      dispatch(
        modal.openModal({
          modalType: "LOGIN_FORM",
          modalProps: {
              raisedClass: isPaymentKiosk ? 'raise payment-kiosk-login-form' : 'raise'
          }
        })
      ),
    go: path => dispatch(pushWithQueryParams(path)),
    openShippingForm: props =>
      dispatch(
        modal.openModal({
          modalType: "SHIPPING_FORM",
          modalProps: props
        })
      ),
    openItemAdded: () =>
      dispatch(
        modal.openModal({
          modalType: "ITEM_ADDED_FORM",
          modalProps: {}
        })
      ),
    fetchMoreProducts: (categoryName, offset, limit) =>
      dispatch(fetchMoreByCategory(categoryName, offset, limit)),
    restoreBody: scrollTop =>
      dispatch({
        type: "RESET_SCROLL_TOP",
        payload: scrollTop
      }),
    setCurrentProduct: product => dispatch(setProduct(product))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetailViewNewKiosk);

const LabResultsWrapperDiv = styled.div`
  display: flex;
  width: 75%;
  @media (min-width: 900px) {
    width: 65%;
  }
  @media (max-width: 768px) {
    margin: 0 auto;
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
    width: 40%;
  }
`;

const AddressWrapperDiv = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 1;
`;

const AttributeNameSpan = styled.div`
  font-weight: 700;
`;



// WEBPACK FOOTER //
// ./src/components/ProductDetailViewNewKiosk/ProductDetailViewNewKiosk.jsx